import React, { useState } from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import PartnerApplicationsTable from "../components/PartnerApplicationsTable";
import ActivePartnersTable from "../components/ActivePartnersTable";
import InactivePartnersTable from "../components/InactivePartnersTable";
import { ToastContainer } from 'react-toastify';

const PartnersApplicationsPage = () => {
  const [activeTab, setActiveTab] = useState('applications');

  return (
    <MasterLayout>
      <ToastContainer />
      <Breadcrumb title="Partnerler" />
      
      <div className="card h-100 p-0 radius-12">
        <div className="card-header border-bottom bg-base py-16 px-24">
          <ul className="nav nav-tabs card-header-tabs" role="tablist">
            <li className="nav-item" role="presentation">
              <button
                className={`nav-link ${activeTab === 'applications' ? 'active' : ''}`}
                onClick={() => setActiveTab('applications')}
                type="button"
              >
                Başvurular
              </button>
            </li>
            <li className="nav-item" role="presentation">
              <button
                className={`nav-link ${activeTab === 'active' ? 'active' : ''}`}
                onClick={() => setActiveTab('active')}
                type="button"
              >
                Aktif Partnerler
              </button>
            </li>
            <li className="nav-item" role="presentation">
              <button
                className={`nav-link ${activeTab === 'inactive' ? 'active' : ''}`}
                onClick={() => setActiveTab('inactive')}
                type="button"
              >
                Pasif Partnerler
              </button>
            </li>
          </ul>
        </div>

        <div className="card-body p-0">
          {activeTab === 'applications' && (
            <PartnerApplicationsTable status="pending" title="Onayda Bekleyen Partner Başvuruları" />
          )}
          {activeTab === 'active' && (
            <ActivePartnersTable />
          )}
          {activeTab === 'inactive' && (
            <InactivePartnersTable />
          )}
        </div>
      </div>
    </MasterLayout>
  );
};

export default PartnersApplicationsPage;
